import React from 'react';

import Layout from '../components/Layout';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 
import a from '../assets/images/a-xx-111-art.jpg';
import b from '../assets/images/a-xx-112-art.jpg';
import c from '../assets/images/a-xx-113-art.jpg';
import d from '../assets/images/a-xx-114-art.jpg';
import e from '../assets/images/a-xx-115-art.jpg';
import f from '../assets/images/a-xx-116-art.jpg';
import g from '../assets/images/a-xx-117-art.jpg';
import h from '../assets/images/a-xx-118-art.jpg';
import i from '../assets/images/a-xx-119-art.jpg';
import j from '../assets/images/a-xx-120-art.jpg';


const pillars = [
  [
    {
      img: a,
      title:'Coconut Tree',
      text: 'This is the coconut tree (Cocos nucifera), a member of the palm tree family. It is highly regarded in India and Hawaii, and was one of only 26 plants that the Polynesians brought to this island in their canoes centuries ago. The coconut also has cultural and religious significance in certain societies, particularly in India, where it is used in Hindu rites. Breaking a coconut at a temple is a blessed offering. '
    },
    {
      img: b,
      title:'Gopuram',
      text: 'This depicts a Gopuram, the monumental tower, usually ornate, at the entrance of a Hindu temple, especially prominent in South Indian temples.'
    },
    {
      img: c,
      title:'Sun and the Moon',
      text: 'This is the Sun and the Moon, rich with meanings in Hindu astrology and philosophical literature.'
    },
    {
      img: d,
      title:'Himalayan Academy',
      text: 'This is the logo of Himalayan Academy, which publishes Hinduism Today magazine and all of Gurudeva’s books and teachings.'
    }
  ],
  
  [
    {
      img: e,
      title:'San Marga',
      text: 'This is the official logo for San Marga. Interpretations include five meditators sitting back to back, the five faces of Sadasiva, the five elements and more.'
    },
    {
      img: f,
      title:'Saiva Siddhanta Church',
      text: 'This is the logo of Saiva Siddhanta Church, founded in 1949 by Satguru Sivaya Subramuniyaswami. It has the holy tripundra of three lines of holy ash and a sandalwood circle and pottu or red dot at the center. The Church is the parent body for Iraivan Temple.'
    },
    {
      img: g,
      title:'Hinduism Today',
      text: 'This is the logo of Hinduism Today, the Hindu family magazine founded by Satguru Sivaya Subramuniyaswami in 1979 and published here by Himalayan Academy to affirm Sanatana Dharma and record the modern history of a billion-strong global religion in renaissance. This award-winning, lavishly illustrated, all-color, computer-produced news and information resource reaches thousands of readers in over 150 countries throughout the world. It is a major part of this monastery’s service to the world. Interpretations of the logo include a cross section of a printing press roller, a modern swastika and two sets of quote marks.'
    },
    {
      img: h,
      title:'Hindu Heritage Endowment',
      text: 'This is the official logo for Hindu Heritage Endowment. Interpretations include a fountain of abundance, the rising up of dharma and spirit and more.'
    }
   ],

    [
      {
        img: i,
        title:'Tyaf',
        text: 'This is the basic Tyaf alphabet, which consists of 23 letters and sounds. It is a meditation in Gurudeva’s language of meditation and one of the 12 meditations he asked us to carve on Iraivan’s pillars. This is the January meditation.'
      },
      {
        img: j,
        title:'Dakshinamurti',
        text: 'This is Dakshinamurti, the “South-facing form.” Lord Siva is depicted as the silent guru sitting under a banyan tree, silently teaching four rishis at His feet. A 12-foot-tall granite Dakshinamurti is located just north of Iraivan Temple, and the sutra, central thread, of this temple is lined up with Siva’s third eye.'
      },
      {
        img: '',
        title:'',
        text: ''
      },
      {
        img: '',
        title:'',
        text: ''
      }


   ]
];
 

const Pillar12 = () => (

  
  <Layout fullMenu>
    <article id="main">
      <header style={{marginBottom:0}}>
      
        <h2 style={{color:'#dd7137'}}>Pillar Twelve</h2>
        <p>Artwork by A. Manivelu </p>
      </header>
      

    

<section className=" style4">     
        <div  > 
 
<div style={{maxWidth:500, padding: 10,marginLeft:'auto', marginRight:'auto'}}>
<h4 style={{textAlign:'center'}}>Top</h4>
         <Carousel showArrows={false}>
                <div>
                    <img className="image" src={pillars[0][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[0][0].title}</h4>
                    <p>{pillars[0][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[0][1].title}</h4>
                    <p>{pillars[0][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[0][2].title}</h4>
                    <p>{pillars[0][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[0][3].title}</h4>
                    <p>{pillars[0][3].text}</p>
                </div>
            </Carousel> 


            <h4 style={{textAlign:'center'}}>Middle</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[1][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[1][0].title}</h4>
                    <p>{pillars[1][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[1][1].title}</h4>
                    <p>{pillars[1][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[1][2].title}</h4>
                    <p>{pillars[1][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[1][3].title}</h4>
                    <p>{pillars[1][3].text}</p>
                </div>
            </Carousel> 
            <h4 style={{textAlign:'center'}}>Bottom</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[2][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[2][0].title}</h4>
                    <p>{pillars[2][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[2][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[2][1].title}</h4>
                    <p>{pillars[2][1].text}</p>
                </div>
                 
            </Carousel> 

            </div>

 
      

        </div>
      </section>
      
    </article>
  </Layout>
);

export default Pillar12;
